import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const icons = {
  ManageSearchIcon
};

const lookingForProducts = {
  id: 'looking-for-products',
  title: 'In Search Of Products',
  type: 'group',
  userRoles: ['Super Admin'],
  children: [
    {
      check: 'view-products',
      id: 'looking-for-products-list',
      title: 'In Search Of Products',
      type: 'item',
      url: '/looking-for-products',
      icon: icons.ManageSearchIcon,
      breadcrumbs: false
    }
  ]
};

export default lookingForProducts;
